import { ProductFruits } from 'react-product-fruits';
import { useProductFruitsSetup } from './hooks/use-product-fruits-setup';

export const ProductFruitsWrapper = () => {
  const { workspaceCode, shouldRender, user } = useProductFruitsSetup();

  if (!shouldRender) {
    return null;
  }

  return <ProductFruits workspaceCode={workspaceCode} language="en" user={user} />;
};
